import React from "react";
import { mathCalculators } from "../Ar/MathCalculator/ConstantsMathCalculator";
import { womenCalculators } from "../Ar/WomenCalculator/ConstantsWomenCalculator";
import { financialCalculators } from "../Ar/FinancialCalculator/ConstantsFinancialCalculator";
import { humanCalculators } from "../Ar/HumanCalculator/ConstantsHumanCalculator";
import { islamicCalculators } from "../Ar/IslamicCalculator/ConstantsIslamicCalculator";
import { studyCalculators } from "../Ar/StudyCalculator/ConstantsStudyCalculator";
import { physicsCalculators } from "../Ar/PhysicsCalculator/ConstantsPhysicsCalculator";
import { healthCalculators } from "../Ar/HealthCalculator/ConstantsHealthCalculator";
import { otherCalculators } from "../Ar/OtherCalculator/ConstantsOtherCalculator";
import { chemistryCalculators } from "../Ar/ChemistryCalculator/ConstantsChemistryCalculator";
import { unitConverters } from "../Ar/UnitConverter/ConstantsUnitConverter";
import { foodCalculators } from "../Ar/FoodCalculator/ConstantsFoodCalculator";
import SearchComponent from "../../Components/SearchComponent";
import { Icons } from "../Icons";

const cardData = [
  {
    cardNumber: 1,
    cardTitle: "حواسب الزمن والتاريخ",
    cardIcon: <Icons.AccessTime />,
    cardItems: humanCalculators,
    calculatorUrl: "/ar/date-time-calculators/",
  },
  {
    cardNumber: 2,
    cardTitle: "حواسب الصحة",
    cardIcon: <Icons.Favorite />,
    cardItems: healthCalculators,
    calculatorUrl: "/ar/health-calculators/",
  },
  {
    cardNumber: 3,
    cardTitle: "حواسب المرأة",
    cardIcon: <Icons.Female />,
    cardItems: womenCalculators,
    calculatorUrl: "/ar/women-calculators/",
  },
  {
    cardNumber: 4,
    cardTitle: "حواسب الرياضيات",
    cardIcon: <Icons.Calculate />,
    cardItems: mathCalculators,
    calculatorUrl: "/ar/math-calculators/",
  },
  {
    cardNumber: 5,
    cardTitle: "حواسب إسلامية",
    cardIcon: <Icons.VolunteerActivism />,
    cardItems: islamicCalculators,
    calculatorUrl: "/ar/zakat-calculators/",
  },
  {
    cardNumber: 6,
    cardTitle: "حواسب المعدلات الجامعية",
    cardIcon: <Icons.School />,
    cardItems: studyCalculators,
    calculatorUrl: "/ar/study-calculators/",
  },
  {
    cardNumber: 7,
    cardTitle: "حواسب الفيزياء",
    cardIcon: <Icons.Science />,
    cardItems: physicsCalculators,
    calculatorUrl: "/ar/physics-calculators/",
  },
  {
    cardNumber: 8,
    cardTitle: "الحواسب المالية",
    cardIcon: <Icons.AttachMoney />,
    cardItems: financialCalculators,
    calculatorUrl: "/ar/financial-calculators/",
  },
  {
    cardNumber: 9,
    cardTitle: "حواسب التحويل",
    cardIcon: <Icons.Transform />,
    cardItems: unitConverters,
    calculatorUrl: "/ar/unit_converter/",
  },
  {
    cardNumber: 10,
    cardTitle: " حواسب عامة",
    cardIcon: <Icons.MoreHoriz />,
    cardItems: otherCalculators,
    calculatorUrl: "/ar/other-calculators/",
  },
  {
    cardNumber: 11,
    cardTitle: "حواسب الكيمياء",
    cardIcon: <Icons.Biotech />,
    cardItems: chemistryCalculators,
    calculatorUrl: "/ar/chemistry-calculators/",
  },
  {
    cardNumber: 12,
    cardTitle: "حواسب الطعام",
    cardIcon: <Icons.Food />,
    cardItems: foodCalculators,
    calculatorUrl: "/ar/food-calculators/",
  },
];

function CardGroups() {
  return (
    <React.Fragment>
      <SearchComponent />
      <br />
      <div
        className="row row-cols-1 row-cols-md-4"
        style={{ position: "relative", zIndex: "1" }}
      >
        {cardData.map((card, index) => (
          <div className="col" xs key={index} style={{ paddingBottom: "10px" }}>
            <div className="card">
              <div className="card-body">
                <div className="p-1 bg-success text-white">
                  <a
                    href={card.calculatorUrl}
                    style={{
                      fontSize: "16px",
                      color: "white",
                      padding: "10px",
                      display: "block",
                    }}
                    aria-label={card.cardTitle}
                  >
                    <div className="card-title">
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        {card.cardIcon}
                      </div>
                      <h2
                        style={{
                          fontSize: "16px",
                          justifyContent: "center",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <span style={{ marginLeft: "10px" }}>
                          {card.cardTitle}
                        </span>
                      </h2>
                    </div>
                  </a>
                </div>
                <hr />
                <div className="card-text">
                  {card.cardItems.map(
                    (item, itemIndex) =>
                      item.showMain && (
                        <a
                          key={itemIndex}
                          href={item.link}
                          className="item-link"
                        >
                          <span style={{ fontSize: "14px" }}>{item.name}</span>{" "}
                          <br />
                        </a>
                      )
                  )}
                </div>
              </div>
              <div className="card-footer" style={{ textAlign: "center" }}>
                <div style={{ paddingBottom: "10px" }}>
                  <a
                    className="btn btn-outline-success"
                    style={{ width: "90%" }}
                    href={card.calculatorUrl}
                  >
                    المزيد
                  </a>
                  <br />
                </div>
              </div>
            </div>
          </div>
        ))}
        <br />
      </div>
      <hr />
      <div className="p-3 mb-2 bg-success text-white">
        في حال لديك أي استعلام أو ترغب من فريقنا بإضافة حواسب أخرى أو حتى تريد
        أن تبلغ عن مشكلة في حاسبة معينة, يرجى إخبارنا على البريد الالكتروني
        التالي : info@do-calculate.com
      </div>
    </React.Fragment>
  );
}

export default CardGroups;